export const ESCALATION_CATEGORY_INFO = {
  expression: { label: "Disrespect & Dismissal", color: "text-amber-800 border-amber-300 bg-amber-50", votable: true },
  behavior_nonviolent: { label: "Unfair Treatment", color: "text-[#1E3A6E] border-[#4FD1C5]/50 bg-[#4FD1C5]/10", votable: true },
  behavior_violent: { label: "Threats or Violence", color: "text-red-700 border-red-300 bg-red-50", votable: false },
};

export const DOCUMENTATION_CATEGORY_INFO = {
  decision: { label: "Unfair Decision" },
  institutional: { label: "Broken System" },
  systemic: { label: "Ongoing Pattern" },
};
